import React, { useState } from "react";
import { Tooltip } from "reactstrap";
import PropTypes from "prop-types";

const TooltipItem = ({ text, target, key }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  return (
    <Tooltip
      placement={"top"}
      isOpen={tooltipOpen}
      target={target}
      toggle={toggle}
    >
      {text}
    </Tooltip>
  );
};

export default TooltipItem;
